<ng-template #summaryContent>
  <div class="summary-panel" [class.inline-panel]="inlineView">
    <div class="summary-header">
      <div>
        <h2>Parcel Summary</h2>
      </div>
      <div class="summary-actions">
        @if (!isLoading) {
          <p-button icon="pi pi-refresh" class="icon-btn action-btn" [text]="true"
          (onClick)="loadSummary()"></p-button>
        }
      </div>
    </div>

    <div class="summary-sections">
      <div class="summary-section-card">
        <div class="section-title-row">
          <h3>Daily</h3>
          <small>Today operations</small>
        </div>
        <div class="section-stat-grid">
          <div class="stat-card inbound">
            <span>Inbound</span>
            <strong>{{ summary.total || 0 }}</strong>
            <small>Today</small>
          </div>
          <div class="stat-card handled">
            <span>Handled</span>
            <strong>{{ summary.handled || 0 }}</strong>
            <small>Today</small>
          </div>
          <div class="stat-card inbound">
            <span>Handled total</span>
            <strong>{{ summary.total_daily_handled || 0 }}</strong>
            <small>Net Total</small>
          </div>
          <div class="stat-card inbound">
            <span>Camera 1</span>
            <strong>{{ summary.total_count_camera1 || 0 }}</strong>
            <small>Captured</small>
          </div>
          <div class="stat-card handled">
            <span>Camera 2</span>
            <strong>{{ summary.total_count_camera2 || 0 }}</strong>
            <small>Captured</small>
          </div>
          <div class="stat-card assigned">
            <span>Camera 3</span>
            <strong>{{ summary.total_count_camera3 || 0 }}</strong>
            <small>Captured</small>
          </div>

        </div>
      </div>

      <div class="summary-section-card">
        <div class="section-title-row">
          <h3>Queued</h3>
          <small>Current queue status</small>
        </div>
        <div class="section-stat-grid">
          <div class="stat-card assigned">
            <span>Assigned to me</span>
            <strong>{{ summary.assigned_to_me || 0 }}</strong>
            <small>Active queue</small>
          </div>
          <div class="stat-card handled">
            <span>All assigned</span>
            <strong>{{ summary.all_assigned || 0 }}</strong>
            <small>Queue load</small>
          </div>
          <div class="stat-card assigned">
            <span>Unassigned</span>
            <strong>{{ summary.all_unassigned || 0 }}</strong>
            <small>Needs action</small>
          </div>
          <div class="stat-card inbound">
            <span>Reprocessing</span>
            <strong>{{ summary.all_reprocessing || 0 }}</strong>
            <small>Active queue</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
@if (inlineView) {
  <ng-container *ngTemplateOutlet="summaryContent"></ng-container>
} @else {
 <div class="card flex justify-center">
    <p-button (click)="op.toggle($event)" icon="pi pi pi-chart-bar" class="icon-btn summary-trigger"  />
    <p-popover #op>
        <ng-container *ngTemplateOutlet="summaryContent"></ng-container>
    </p-popover>
</div>
}

 